const getCredentials = (name) => window._credentials[name]

export const usePusherCredentials = () => getCredentials('pusher')

export const useZendeskCredentials = () => getCredentials('zendesk')
